import React, { useId } from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Settings tabs; each part uses its own slice of it */
import styles from './notifications.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface Props<T extends string | number> {
  /** The radio group name; also the accessible name of the group. */
  name: string;
  label: string;
  options: { value: T; label: string }[];
  value: T;
  disabled: boolean;
  onChange: (value: T) => void;
}

/** A mono segmented choice made of radio inputs (design settings-redesign c1: threshold, floor). */
function ChoiceChipsComponent<T extends string | number>({
  name,
  label,
  options,
  value,
  disabled,
  onChange,
}: Props<T>) {
  const groupId = useId();
  return (
    <fieldset className={`${styles.chips}${disabled ? ` ${styles.chipsDisabled}` : ''}`} disabled={disabled}>
      <legend className="visually-hidden">{label}</legend>
      {options.map((option) => (
        <label key={String(option.value)} className={styles.chip} htmlFor={`${groupId}-${option.value}`}>
          <input
            id={`${groupId}-${option.value}`}
            type="radio"
            className="visually-hidden"
            name={name}
            value={String(option.value)}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          {option.label}
        </label>
      ))}
    </fieldset>
  );
}

export const ChoiceChips = TypedMemo(ChoiceChipsComponent);
